import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import topdev from "assets/img/topdev.jpg";

import first from "assets/img/faces/first.png";
import second from "assets/img/faces/second.png";
import third from "assets/img/faces/third.png";
import other from "assets/img/faces/winner.png";
import validate from "assets/img/topdev-validate.jpg";


import styles from "assets/jss/material-kit-react/views/topdev.js";
import Axios from "axios";
import Config from "../../../config.js"
import swal from 'sweetalert'
import Ads from "../../Main/Sections/Ads4.js";
import { Helmet } from 'react-helmet'



const useStyles = makeStyles(styles);

export default function TopDevMainPage(props) {
    const classes = useStyles();
    const [challenges, setChallenges] = useState(null);

    const { ...rest } = props;
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );
    var next = (register, challengeId) => {
        props.history.push("/TopDev/Challenges/" + challengeId);
    }
    var start = (challengeId, index) => {
        if (!challenges[index].active) {
            return swal("تا شروع مسابقه صبر کنید.")
        }
        if (localStorage.getItem('token')) {
            Axios.post(Config.api + "Challenge/RegisterInChallenge", {
                challengeId: challengeId
            },
                {
                    headers: {
                        apikey: Config.apikey,
                        Authorization: "Bearer " + localStorage.getItem('token')

                    }
                }).then(async (result) => {
                    next(1, challengeId);
                }).catch((err) => {
                    if (err && err.response && err.response.status && err.response.status === 401) {
                        swal("برای شروع مسابقه، باید وارد شوید.").then(() => {
                            localStorage.removeItem('token');
                            props.history.push("/SignIn");
                        })
                    }
                    else if (err && err.response && err.response.status && err.response.status === 422)
                        swal("اطلاعات ارسالی نادرست است.");
                    else if (err && err.response && err.response.status && err.response.status === 409) {
                        next(0, challengeId);
                    }
                    else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
                        swal(err.response.data.message.pr);
                    else swal("خطایی رخ داده است.")
                })
        } else {
            swal("برای شروع مسابقه، باید وارد شوید.").then(() => {
                localStorage.removeItem('token');
                props.history.push("/SignIn");
            })
        }
    }
    useEffect(() => {
        Axios.post(Config.api + "Challenge/GetChallenges", {
            "filter": "show=true"
        },
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                console.log(result)
                setChallenges(result.data.data);
            }).catch((err) => {
                if (err && err.response && err.response.status && err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                else if (err && err.response && err.response.status && err.response.status === 422)
                    swal("اطلاعات ارسالی نادرست است.");
                else if (err && err.response && err.response.status && err.response.status === 409) {
                    next(0);
                }
                else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
                    swal(err.response.data.message.pr);
                else swal("خطایی رخ داده است.")
            })
    }, []);
    return (
        <div>
            <Header
                color="transparent"
                brand="Material Kit React"
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 200,
                    color: "white"
                }}
                {...rest}
            />
            <Helmet>
                <title>کمپ آموزشی شریف | مسابقه برنامه نویسی topdev</title>
                <meta name="description" content="مسابقه الگوریتمی آنلاین و حضوری topdev با هدف یافتن استعدادهای برنامه نویسی." />
                <meta name="" content="topdev, contest, programming,java,c#,csharp,cpp,c++,سی شارپ، برنامه نویسی، مسابقه برنامه نویسی" />
            </Helmet>
            <Parallax small filter image={require("assets/img/bg8.jpg")} />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div>
                    <div className={classes.container}>
                    
                        <GridContainer justify="center" className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.topdev}>
                                    <div>
                                        <img src={topdev} alt="..." className={imageClasses} />
                                    </div>
                                    <div className={classes.name}>
                                        <h3 className={classes.title}>مسابقات برنامه نویسی آنلاین کمپ آموزشی شریف</h3>
                                    </div>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                        <GridItem xs={12} sm={12} md={12}>
                            {<h4><span style={{color:"red"}}>توجه:</span> لطفا از پنل کاربری بخش اطلاعات شخصی و رزومه، رزومه کاری خود را تکمیل کنید.
                            </h4>}
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                        <GridItem xs={12} sm={12} md={3}>
                                <Card className={classes.root + " " + classes.card} variant="outlined">
                                    <CardActionArea className={classes.cardMain}>
                                        <CardMedia
                                            className={classes.media}
                                            image={"https://sharifcamp.ir/assets/images/opening.png"}
                                            title="TopDev Opening"
                                        />
                                        <CardContent>
                                            <Typography gutterBottom variant="h6" component="h3">
                                                افتتاحیه
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary" component="p">
                                                ساعت 9 تا 9:30 پنجشنبه 27 اردیبهشت
                                            </Typography>
                                        </CardContent>
                                    </CardActionArea>
                                    <CardActions>
                                        <div className={classes.extra}>
                                        </div>
                                        <Button href="https://sharifcamp.ir/meeting/topdev/" size="small" color="primary">
                                            ورود
                                        </Button>
                                    </CardActions>
                                </Card>
                            </GridItem>
                            {challenges && challenges.map((challenge, index) => {

                                return (
                                    <GridItem xs={12} sm={12} md={3}>
                                        <Card className={classes.root + " " + classes.card} variant="outlined">
                                            <CardActionArea className={classes.cardMain}>
                                                <CardMedia
                                                    className={classes.media}
                                                    image={challenge.image}
                                                    title="TopDev"
                                                />
                                                <CardContent>
                                                    <Typography gutterBottom variant="h6" component="h3">
                                                        {challenge.title}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary" component="p">
                                                        {challenge.description}
                                                    </Typography>
                                                </CardContent>
                                            </CardActionArea>
                                            <CardActions>
                                                <div className={classes.extra}>
                                                </div>
                                                <Button onClick={() => start(challenge._id, index)} size="small" color="primary">
                                                    شروع
                                                </Button>
                                            </CardActions>
                                        </Card>
                                    </GridItem>
                                )
                            })}
                            <GridItem xs={12} sm={12} md={3}>
                                <Card className={classes.root + " " + classes.card} variant="outlined">
                                    <CardActionArea className={classes.cardMain}>
                                        <CardMedia
                                            className={classes.media}
                                            image={"https://sharifcamp.ir/assets/images/winner.png"}
                                            title="TopDev Validation"
                                        />
                                        <CardContent>
                                            <Typography gutterBottom variant="h6" component="h3">
                                                اختتامیه
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary" component="p">
                                            ساعت 9 تا 11 جمعه 28 اردیبهشت 
                                            </Typography>
                                        </CardContent>
                                    </CardActionArea>
                                    <CardActions>
                                        <div className={classes.extra}>
                                        </div>
                                        <Button href="https://sharifcamp.ir/meeting/topdev/" size="small" color="primary">
                                            ورود
                                        </Button>
                                    </CardActions>
                                </Card>
                            </GridItem>
                        </GridContainer>
                         
                    </div>
                    <GridContainer className={classes.box}>
                        <GridItem xs={12} sm={12} md={12}>
                            <Ads/>
                            </GridItem>
                        </GridContainer>
                </div>
               
            </div>
           
            <Footer />
        </div>
    );
}
